var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuilderAlignmentRight = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3188 3C20.6949 3.00036 20.9996 3.30512 21 3.68115V20.3188C20.9996 20.6949 20.6949 20.9996 20.3188 21C19.9425 21 19.6366 20.6951 19.6362 20.3188V3.68115C19.6366 3.3049 19.9425 3 20.3188 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7.62451C15.8283 7.62451 16.4998 8.2963 16.5 9.12451V15C16.5 15.8284 15.8284 16.5 15 16.5H4.5C3.67158 16.5 3.00002 15.8284 3 15V9.12451C3.00025 8.29629 3.67173 7.62451 4.5 7.62451H15ZM5.25 9C4.83579 9 4.5 9.33579 4.5 9.75V14.25C4.5 14.6642 4.83579 15 5.25 15H14.25C14.6642 15 15 14.6642 15 14.25V9.75C15 9.33579 14.6642 9 14.25 9H5.25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuilderAlignmentRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/builder-alignment-right.b9974d584b6fcb5ed1c4da0b5c8c99f2.svg";